<template>
  <div :class="showClass">
    <div class="comments" v-loading="loading">
      <single-comment
        v-for="comment in comments"
        :key="comment.id"
        :comment='comment'
        :post="post"
        @setTrust="setTrust"
      />
    </div>
  </div>
</template>

<script>
  // api
  import { getPostsCommentsApi } from '@/api/publications';

  // components
  import SingleComment from './SingleComment';

  // api
  import { setCommentTrustApi } from '@/api/publications';

  export default {
    name: 'Commentaries',
    props: {
      post: {
        type: Object
      },
    },
    data() {
      return {
        limit: 20,
        start: 0,
        comments: [],
        loading: false,
      };
    },
    methods: {
      setTrust({commentId, postId, trust}) {
        const params = {
          comment_id: commentId,
          post_id: postId,
          owner_id: this.post.owner_id,
          network_id: this.post.network_id,
          trust: trust
        };

        setCommentTrustApi(params).then(() => {
          this.comments = this.comments.map(item => {
            if (item.id === commentId) {
              item.trust_coment = trust;
            }

            return item;
          });
        });
      },
      loadComments(post) {
        this.loading = true;
console.log('posts', post)
        const params = {
          from: post.created_date,
          thread_id: this.$route.params.threadId,
          limit: this.limit,
          start: this.start,
          owner_id: post.owner_id,
          post_id: post.id,
          network_id: post.network_id,
        };

        getPostsCommentsApi(params).then((resp) => {
          this.comments = [...this.comments, ...resp.data.commentaries];
          this.start = this.comments.length;
          this.loading = false;
        });
      }
    },
    computed: {
      showClass() {
        return this.post.showComment ? 'comments-wrap comments-wrap--show' : 'comments-wrap';
      }
    },
    watch: {
      post: {
        handler: function (post) {
          if (post.firstLoad) {
            this.loadComments(post);
          }
        },
        deep: true
      },
    },
    components: {
      SingleComment,
    },
  };
</script>

<style>
  .comments-wrap {
    display: none;
    position: relative;
    margin-top: 20px;
  }
  .comments {
    box-sizing: border-box;
    margin-bottom: -20px;
    width: 100%;
    max-height: 600px;
    overflow-y: auto;
    border-top: 1px solid #ebebeb;
    background-color: #F5F7FA;
  }
  .comments-wrap--show {
    display: block;
  }
</style>
